import {
  IPaymentBookInfo,
  IPaymentDetailInfo,
  PaymentDetailInfo,
} from "@/domain/entities/payment";
import { IPaymentInfoType } from "@/domain/entities/payment/paymentInfo.types";
import {
  HttpPaymentBookInfo,
  HttpPaymentDetailInfo,
  IPaymentDetailInfoParser,
} from "@/repositories/payment/paymentRepository.types";
import { ParseError } from "@/repositories/shared/errors/parseError";
import dayjs from "dayjs";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";

function parseBookInfos(data: HttpPaymentBookInfo[]) {
  const bookInfos: IPaymentBookInfo[] = [];
  data.forEach((info: HttpPaymentBookInfo) => {
    const bookInfo: IPaymentBookInfo = {
      bookId: info.bookUid,
      bookDetailId: info.bookDetailUid,
    };
    bookInfos.push(bookInfo);
  });
  return bookInfos;
}

@injectable()
export class PaymentInfoDetailParser implements IPaymentDetailInfoParser {
  constructor() {}

  toDomain(
    data: HttpPaymentDetailInfo
  ): Result<IPaymentDetailInfo, ParseError> {
    try {
      const paymentDetailInfoData: IPaymentDetailInfo = {
        type:
          data.payTypeCode === "PYT-PAY"
            ? IPaymentInfoType.PAID
            : IPaymentInfoType.CANCELED,
        payUid: data.payUid,
        amount: data.amount,
        createdAt: dayjs(data.endTs).format("YYYY-MM-DD HH:mm"),
        updatedAt: dayjs(data.statusTs).format("YYYY-MM-DD HH:mm"),
        bookInfos: parseBookInfos(data.details ?? []),
      };
      const paymentDetailInfo = new PaymentDetailInfo(paymentDetailInfoData);
      return ok(paymentDetailInfo);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
